export const ADMINISTRATION_UPSERT_MUTATION_KEY = ['administration-upsert'] as const;
export const ADMINISTRATION_DELETE_MUTATION_KEY = ['administration-delete'] as const;
export const CONSENT_UPDATE_MUTATION_KEY = ['consent-update'] as const;
export const SIGN_OUT_MUTATION_KEY = ['sign-out'] as const;
export const TASK_ADD_MUTATION_KEY = ['task-add'] as const;
export const TASK_UPDATE_MUTATION_KEY = ['task-update'] as const;
export const TASK_VARIANT_ADD_MUTATION_KEY = ['task-variant-add'] as const;
export const TASK_VARIANT_UPDATE_MUTATION_KEY = ['task-variant-update'] as const;
export const USER_UPDATE_MUTATION_KEY = ['user-update'] as const;
export const COMPLETE_ASSESSMENT_MUTATION_KEY = ['assessment', 'complete'] as const;
